import { UnderConstructionPage } from '@components/app/UnderConstructionPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/courses')({
  component: UnderConstructionPage,
})